import script from "./ViewDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ViewDetail.vue?vue&type=style&index=0&id=6e4b2a12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e4b2a12"]])

export default __exports__